<ng-template #modalTemplate>
  <div class="modal-header">
    <h4 class="modal-title pull-left">{{ title }}</h4>
  </div>
  <div class="modal-body box-parent">
    <div class="row" [formGroup]="departmentForm">
      <div class="col">
        <div class="form-label-group">
          <input type="text"
              id="department_id"
              class="form-control"
              formControlName="code"
              placeholder="{{'DEPARTMENT.LIST.FILTER.DEPARTMENT-ID' | translate}}">
          <label for="department_id">{{'DEPARTMENT.LIST.FILTER.DEPARTMENT-ID' | translate}}</label>
        </div>
        <div class="form-label-group">
          <input type="text"
              id="department_name_en"
              class="form-control"
              formControlName="nameEng"
              placeholder="{{'DEPARTMENT.LIST.FILTER.DEPARTMENT-NAME' | translate}}(EN)">
          <label for="department_name_en">{{'DEPARTMENT.LIST.FILTER.DEPARTMENT-NAME' | translate}} (EN)</label>
        </div>
        <div class="form-label-group">
          <input type="text"
              id="department_name_th"
              class="form-control"
              formControlName="nameThai"
              placeholder="{{'DEPARTMENT.LIST.FILTER.DEPARTMENT-NAME' | translate}}(TH)">
          <label for="department_name_th">{{'DEPARTMENT.LIST.FILTER.DEPARTMENT-NAME' | translate}} (TH)</label>
        </div>
        <div class="form-label-group">
          <input type="text"
              id="department_abbreviation"
              class="form-control"
              formControlName="abbreviation"
              placeholder="{{'DEPARTMENT.LIST.FILTER.DEPARTMENT-ABBREVIATION' | translate}}">
          <label for="department_abbreviation">{{'DEPARTMENT.LIST.FILTER.DEPARTMENT-ABBREVIATION' | translate}}</label>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer m-b-0">
      <div class="col">
        <div class="row m-b-5">
          <div class="col text-center text-red">{{ errorMessage ? errorMessage : '&nbsp;' }}</div>
        </div>
        <div class="row justify-content-center">
          <div class="col">
            <button class="btn btn-dv btn-clean btn-wide m-r-20" (click)="close()">{{'COMMON.CANCEL' | translate}}</button>
          </div>
          <button class="col-auto btn btn-dv btn-wide pull-right" (click)="submit()">{{ selectedDepartment ? ('PROFILE.PASSWORD.CONFIRM' | translate) : ('PROFILE.LIST.MODAL.SAVE' | translate) }}</button>
        </div>
      </div>
  </div>
</ng-template>



// WEBPACK FOOTER //
// /opt/app/src/app/features/department/department-list-detail/department-list-detail.component.html